import {
  IInternalUser,
  ISellerRepCodes
} from '../../store/ducks/internal-user/types';
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';

interface ICreateSellerRep {
  name: string;
  email: string;
  salesRepCode: string[];
  coreTeam: boolean;
  searchCustomerType: string;
}
export class AccessInternalManagementService extends EGerdauService {
  static async getSellerReps(): Promise<IInternalUser[]> {
    const headers = new EGerdauService().getHeaders();

    const internalUserResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.SALES_REPRESENTATIVE}`,
      { headers }
    );

    const internalUsers: IInternalUser[] =
      internalUserResponse.data.users || [];
    return internalUsers;
  }

  static async getSellerRepCodes(): Promise<ISellerRepCodes[]> {
    const headers = new EGerdauService().getHeaders();

    const internalUserResponse = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.SALES_REP_CODES}`,
      { headers }
    );

    const codes: ISellerRepCodes[] = internalUserResponse.data.items || [];
    return codes;
  }

  static async createSellerRep(
    bodyData: ICreateSellerRep
  ): Promise<IInternalUser> {
    const headers = new EGerdauService().getHeaders();

    const internalUserResponse = await customersAuthorizationApi.post(
      `${ECustomerAuthorizationEndpoints.SALES_REPRESENTATIVE}`,
      bodyData,
      { headers }
    );

    const internalUsers: IInternalUser = internalUserResponse.data;
    if (!internalUsers) {
      throw new Error();
    }
    return internalUsers;
  }

  static async deactivateSellerRep(
    uuid: string
  ): Promise<{ user: { id: string; name: string; email: string } }> {
    const headers = new EGerdauService().getHeaders();

    const internalUserResponse = await customersAuthorizationApi.patch(
      `${ECustomerAuthorizationEndpoints.USERS}/${uuid}`,
      {
        user: {
          status: 'deactive'
        }
      },
      { headers }
    );

    const internalUsers: { user: { id: string; name: string; email: string } } =
      internalUserResponse.data.user || {};
    return internalUsers;
  }
}
